import React, { Component } from "react";
import Select from 'react-select';

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

// import Component
import {
  Card,
  Col,
  Row,
  CardBody,
  Label,
  Button,
  Form,
  Input,
  Container,
  Toast,
  ToastHeader,
  ToastBody,
} from "reactstrap";

// datatable related plugins
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";

import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";

import "./index.scss";
import axios from "axios";
import * as url from "../../helpers/url_helper";

const {REACT_APP_BACK_URL} = process.env;
const {REACT_APP_FRONT_URL} = process.env;

// Table data
let dodFiles = [];
let rolesTerritoire = ['TER_NORD_EST','TER_NORD_OUEST','TER_SUD_EST','TER_SUD_OUEST'];
let isDod = false;
let numeroCgosSso = '';
let exerciceSso = '';

export default class index extends Component {
  
  constructor(props) {
    super(props);
    this.showToast = this.showToast.bind(this);
    const userRoles = this.getAuthUser().roles;
    if (userRoles.length > 0) {
      isDod = false;
      rolesTerritoire.forEach(roleCode => {
        if (userRoles.some( role => role.rolCode === roleCode )) {
          isDod = true;
        }  
      });
      if (!isDod) {
        window.location = '/logout';
      }
    }
    this.handleSearchFile = this.handleSearchFile.bind(this);
    this.state = {
      toast: false,
      page: 1,
      sizePerPage: 10,
      fileData: dodFiles,
      columns : [
        {
          dataField: "libelle",
          text: "Libellé",
          sort: true,
        },
        {
          dataField: "exercice",
          text: "Exercice",
          sort: true,
        },
        {
          dataField: "dateCreation",
          text: "Date création",
          sort: true,
        },
        {
          dataField: "dateModification",
          text: "Date dernière modification",
          sort: true,
        },
        {
          dataField: "statut",
          text: "Statut",
          sort: true,
        },
        {
          dataField: "view",
          text: "Afficher",
          sort: false,
          formatter: this.linkShow,
        }
      ]
    };
    if (localStorage.getItem("numeroCgos") !== '' && localStorage.getItem("exercice") !== '') {
      this.searchDod(localStorage.getItem("numeroCgos"), localStorage.getItem("exercice"));
      numeroCgosSso = localStorage.getItem("numeroCgos");
      exerciceSso = localStorage.getItem("exercice");
      localStorage.removeItem("numeroCgos");
      localStorage.removeItem("exercice");
    }
  }

  showToast = () => {
    this.setState ({
      toast: true
    });
  };

  getAuthUser = () => {
    if (localStorage.getItem("authUser")) {
      return JSON.parse(localStorage.getItem("authUser"));
    }
  }

  linkShow = (cell, row) => {
    let link = REACT_APP_FRONT_URL + "/dod/" + row.iijId +
     "?token=eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJORUEiLCJyb2xlcyI6IlBVVCxHRVQiLCJpYXQiOjE2NzUzMzQyMzEsImV4cCI6MTczODM2NDQwMH0.pZ0GSoBycM4FCWez0oPil666D4QdCWvUMUMZOmeH37m6vFxBBE316Bfh_GvbaHpGDoS8bKrnW_u3GRhVXAJOjw";
    return (
      <a href={link} target="_blank" rel="noopener noreferrer">
        <i className="bx bx-show" style={{ fontSize: "25px", color: "#00a6e2" }}/>
      </a>
    );
  };

  handleSearchFile = (e) => {
    e.preventDefault();
    let numeroCgos = e.target.numeroCgos.value;
    let exercice = e.target.exercice.value;
    this.searchDod(numeroCgos, exercice);
  }

  searchDod = (numeroCgos, exercice) => {
    this.setState ({
      toast: false,
      page: 1,
      sizePerPage: 10,
      fileData: [],
    })
    axios.get(REACT_APP_BACK_URL + url.POST_DOD_FILE_SEARCH + "?numeroCgos="+numeroCgos+"&exercice="+exercice)
    .then((response) => {
      dodFiles = response.data;
      this.setState ({
        toast: false,
        page: 1,
        sizePerPage: 10,
        fileData: dodFiles,
      })
    },
    (error) => {
      this.showToast();
    });
  }

  render() {
    const defaultSorted = [
      {
        dataField: "dateCreation",
        order: "asc",
      },
    ];

    const pageOptions = {
      sizePerPage: 10,
      totalSize: dodFiles.length,
      custom: true,
    };

    const { SearchBar } = Search;
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs title="File Handler Viewer" breadcrumbItem="Suivi justificatifs des DOD Web" />
            <div className="d-xl-flex">
              <div className="w-100">
                <div className="d-md-flex">
                  <div className="w-100">
                    <Card>
                      <CardBody>
                        <div>
                          <Form onSubmit={this.handleSearchFile}>
                            <Row>
                              <Col lg={12}>
                                <Card>
                                  <CardBody>
                                    <Row>
                                      <div className="col-md-4 mb-4"></div>

                                      <div className="col-md-2 mb-2">
                                        <Label
                                          htmlFor="horizontal-numero-cgos-Input"
                                          className="col-form-label"
                                        >
                                          Numéro CGOS
                                        </Label>
                                        <Col>
                                          <Input
                                            type="text"
                                            className="form-control"
                                            id="horizontal-numero-cgos-Input"
                                            name="numeroCgos"
                                            value={numeroCgosSso}
                                          />
                                        </Col>
                                      </div>
                                      
                                      <div className="col-md-2 mb-2">
                                        <Label
                                          htmlFor="horizontal-exercice-Input"
                                          className="col-form-label"
                                        >
                                          Exercice
                                        </Label>
                                        <Col>
                                          <Input
                                            type="number"
                                            className="form-control"
                                            id="horizontal-exercice-Input"
                                            name="exercice"
                                            value={exerciceSso}
                                          />
                                        </Col>
                                      </div>
                                    </Row>
                                    <Row>
                                      <center>
                                        <Col lg={12}>
                                          <div className="mt-3">
                                            <Button
                                              type="submit"
                                              color="primary"
                                              className="w-md"
                                            >
                                              Rechercher
                                            </Button>
                                            <div
                                              className="position-fixed top-0 end-0 p-3"
                                              style={{ zIndex: "1005", color: "red" }}
                                            >
                                              <Toast isOpen={this.state.toast}>
                                                <ToastHeader toggle={this.showToast}>
                                                  Erreur !
                                                </ToastHeader>
                                                <ToastBody>
                                                  Veuillez renseigner tous les champs
                                                </ToastBody>
                                              </Toast>
                                            </div>
                                          </div>
                                        </Col>
                                      </center>
                                    </Row>
                                  </CardBody>
                                </Card>
                              </Col>
                            </Row>
                          </Form>
                        </div>
                        <div className="container-fluid">
                          <Row>
                            <Col className="col-12">
                              <Card>
                                <CardBody>
                                  <PaginationProvider
                                    pagination={paginationFactory(pageOptions)}
                                    keyField="dateCreation"
                                    columns={this.state.columns}
                                    data={this.state.fileData}
                                  >
                                    {({ paginationProps, paginationTableProps }) => (
                                      <ToolkitProvider
                                        keyField="dateCreation"
                                        columns={this.state.columns}
                                        data={this.state.fileData}
                                        search
                                      >
                                        {toolkitProps => (
                                          <React.Fragment>
                                            <Row className="mb-2">
                                              <Col md="4">
                                                <div className="search-box me-2 mb-2 d-inline-block">
                                                  <div className="position-relative">
                                                    <SearchBar
                                                      {...toolkitProps.searchProps}
                                                    />
                                                    <i className="bx bx-search-alt search-icon" />
                                                  </div>
                                                </div>
                                              </Col>
                                            </Row>

                                            <Row>
                                              <Col xl="12">
                                                <div className="table-responsive">
                                                  <BootstrapTable
                                                    keyField={"id"}
                                                    responsive
                                                    bordered={true}
                                                    striped={true}
                                                    defaultSorted={defaultSorted}
                                                    classes={
                                                      "table align-middle table-nowrap"
                                                    }
                                                    headerWrapperClasses={"thead-light"}
                                                    {...toolkitProps.baseProps}
                                                    {...paginationTableProps}
                                                  />
                                                </div>
                                              </Col>
                                            </Row>

                                            <Row className="align-items-md-center mt-30">
                                              <Col className="inner-custom-pagination d-flex">
                                                <div className="d-inline">
                                                  <SizePerPageDropdownStandalone
                                                    {...paginationProps}
                                                  />
                                                </div>
                                                <div className="text-md-right ms-auto">
                                                  <PaginationListStandalone
                                                    {...paginationProps}
                                                  />
                                                </div>
                                              </Col>
                                            </Row>
                                          </React.Fragment>
                                        )}
                                      </ToolkitProvider>
                                    )}
                                  </PaginationProvider>
                                </CardBody>
                              </Card>
                            </Col>
                          </Row>
                        </div>
                      </CardBody>
                    </Card>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
